<template>
  <div id="app">
    <navigation class="navigation"></navigation>
    <div class="container">
      <router-view/>
      <footers class="footers"></footers>
    </div>
  </div>
</template>

<script>
import navigation from './components/navigation.vue';
import footers from './components/footers.vue';
export default {
  name: 'App',
  components: {
    navigation,
    footers,
  }
}
</script>

<style>
@import url("./scss/common.scss");
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.navigation{
  position: fixed;
  top: 0;
  z-index:100;
}
.container{
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  justify-content:end;
}
.footers{

}
</style>



// WEBPACK FOOTER //
// src/App.vue